import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/core/styles";
import { useRest, useRestRefresh } from "@karpeleslab/react-klbfw-hooks";
import { rest, getPrefix } from "@karpeleslab/klbfw";
import { Link } from "react-router-dom";
import moment from "moment";
import clsx from "clsx";
import { error, success } from "components/Toast/Toast";

// material ui
import { Modal, Typography } from "@material-ui/core";

// component
import Loading from "components/Loading/Loading";
import Button from "components/Btns/Btn";
import HelmetComponents from "components/Helmet/Helmet";

// utils
import { memberIsActive } from "utils/MemberRequired";

// styles
import styles from "../MyPage.module.scss";

//img

// const

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    position: "absolute",
    backgroundColor: "#fff",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(6),
  },
}));

const MemberShip = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const [user] = useRest("User:get");
  const userRefresh = useRestRefresh("User:get");
  const [memberShip, setMemberShip] = useState(null);
  const [memberShipInfo, setMemberShipInfo] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (user !== null && user?.data !== null) {
      rest("Membership/@fanclub/User/@")
        .then((data) => {
          setMemberShip(memberIsActive(data));
          setMemberShipInfo(data);
        })
        .catch(() => {
          setMemberShip(false);
        });
    } else {
      setMemberShip(false);
    }
  }, [user, setMemberShip]);

  const unsubscribe = () => {
    rest("Membership/@fanclub/User/@:unsubscribe", "POST")
      .then(() => {
        success("mypage_unsubscribe_success", true, {
          position: "top-center",
          autoClose: 1500,
          onClose: () => {
            userRefresh();
          },
        });
      })
      .catch((err) => {
        error(err.message, false, {
          position: "top-center",
          autoClose: 3000,
        });
      });
  };

  return (
    <>
      <HelmetComponents>
        <title>
          {t("maypage_tab_membership")} - {t("ccommon_meta_title")}
        </title>
        <link
          rel="canonical"
          href={`https://www.yukihayashi.net${getPrefix()}/`}
        />
        <meta
          property="og:title"
          content={`${t("maypage_tab_membership")} - ${t(
            "ccommon_meta_title"
          )}`}
        />
        <meta
          property="og:url"
          content={`https://www.yukihayashi.net${getPrefix()}/`}
        />
      </HelmetComponents>
      <div>
        <p className={styles["mypage-back"]}>
          <Link className={styles["mypage-back-link"]} to="/mypage">
            {t("mypage_back")}
          </Link>
        </p>
        <h3 className="c-ttl-5" style={{ marginBottom: "20px" }}>
          {t("maypage_tab_membership")}
        </h3>
        {memberShip === null && memberShipInfo === null && <Loading />}
        {memberShip === false && memberShipInfo === null && (
          <div>
            <div className={clsx(`${styles["member-ship-plan"]}`)}>
              <p className={styles["member-ship-plan-invite"]}>
                {t("mypage_membership_invite")}
              </p>
              <div className={styles["member-ship-btn-group"]}>
                <Link to="/subscribe" className={styles["member-ship-btn"]}>
                  {t("mypage_membership_add")}
                </Link>
              </div>

              <div className={styles["member-ship-withdrawal"]}>
                <p>{t("maypage_user_withdrawal_text")}</p>
                <Link
                  to="/withdrawal"
                  className={`${styles["member-ship-btn"]} ${styles["member-ship-btn-delete"]}`}
                >
                  {t("maypage_user_withdrawal_btn")}
                </Link>
              </div>
            </div>
          </div>
        )}
        {memberShip !== null && memberShipInfo !== null && (
          <div>
            <div
              className={clsx(
                `${styles["member-ship-plan"]} ${
                  styles[
                    `member-ship-plan-${memberShipInfo?.data.Membership_Plan.Catalog_Product[
                      "Basic.Name"
                    ].toLowerCase()}`
                  ]
                }`
              )}
            >
              <h3
                className={styles["member-ship-plan-title"]}
                dangerouslySetInnerHTML={{
                  __html: t(
                    `${memberShipInfo?.data.Membership_Plan.Catalog_Product[
                      "Basic.Name"
                    ].toLowerCase()}`
                  ),
                }}
              />
              <dl
                className={`${styles["member-ship-plan-benefits"]} ${
                  styles[
                    `member-ship-plan-benefits-${memberShipInfo?.data.Membership_Plan.Catalog_Product[
                      "Basic.Name"
                    ].toLowerCase()}`
                  ]
                }`}
              >
                <dt>{t("mypage_membership_expires")}</dt>
                <dd>
                  {moment(memberShipInfo?.data.Expires.iso).format(
                    "YYYY-MM-DD HH:mm:ss"
                  )}
                </dd>
              </dl>

              {moment().isAfter(moment(memberShipInfo?.data.Expires.iso)) && (
                <dl
                  className={`${styles["member-ship-plan-benefits"]} ${
                    styles[
                      `member-ship-plan-benefits-${memberShipInfo?.data.Membership_Plan.Catalog_Product[
                        "Basic.Name"
                      ].toLowerCase()}`
                    ]
                  }`}
                >
                  <dt>{t("mypage_membership_status")}</dt>
                  <dd>{t("mypage_membership_status_name")}</dd>
                </dl>
              )}
              {((moment().isAfter(moment(memberShipInfo?.data.Expires.iso)) &&
                memberShipInfo?.data.Status !== "paid") ||
                (moment().isAfter(moment(memberShipInfo?.data.Expires.iso)) &&
                  memberShipInfo?.data.Status === "new")) && (
                <div className={styles["member-ship-btn-group"]}>
                  <Link to="/subscribe" className={styles["member-ship-btn"]}>
                    {t("mypage_membership_update")}
                  </Link>
                </div>
              )}
              {((moment().isBefore(moment(memberShipInfo?.data.Expires.iso)) &&
                memberShipInfo?.data.Status === "paid") ||
                (moment().isBefore(moment(memberShipInfo?.data.Expires.iso)) &&
                  memberShipInfo?.data.Status === "new")) && (
                <>
                  <div className={styles["member-ship-btn-group"]}>
                    <Link to="/subscribe" className={styles["member-ship-btn"]}>
                      {t("mypage_membership_change_plan")}
                    </Link>
                    <p
                      style={{
                        marginTop: "20px",
                        textAlign: "center",
                        color: "#DE0000",
                        fontWeight: "bold",
                      }}
                      dangerouslySetInnerHTML={{
                        __html: t("mypage_membership_withdrawal_text_2"),
                      }}
                    ></p>
                    <p
                      className={`${styles["member-ship-btn"]} ${styles["member-ship-btn-delete"]}`}
                      onClick={() => {
                        setOpen(true);
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      {t("mypage_membership_withdrawal")}
                    </p>
                    <p style={{ marginTop: "10px", textAlign: "center" }}>
                      {t("mypage_membership_withdrawal_text")}
                    </p>
                  </div>
                  <div className={styles["member-ship-withdrawal"]}>
                    <Link
                      to="/withdrawal"
                      className={`${styles["member-ship-btn-delete-text"]}`}
                    >
                      {t("maypage_user_withdrawal_btn")}
                    </Link>
                  </div>
                </>
              )}
            </div>
          </div>
        )}
      </div>
      <Modal
        className={classes.modal}
        open={open}
        onClose={() => {
          setOpen(false);
        }}
      >
        <div className={classes.paper}>
          <Typography
            className={styles["member-ship-modal-title"]}
            align="left"
            variant="h6"
            component="h2"
          >
            {t("mypage_modal_title_cancel")}
          </Typography>
          <p
            className={styles["member-ship-modal-text-margin"]}
            dangerouslySetInnerHTML={{ __html: t("mypage_modal_text_cancel") }}
          ></p>
          <div className={styles["member-ship-modal-btns-group"]}>
            <Button
              onClick={() => {
                setOpen(false);
              }}
              iconPosition="noting"
            >
              {t("mypage_modal_btn_close")}
            </Button>
            <Button
              onClick={() => {
                unsubscribe();
              }}
              className={styles["member-ship-btn-delete"]}
              iconPosition="noting"
            >
              {t("mypage_membership_withdrawal_btn")}
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default MemberShip;
